import React from 'react';
import { RandomCompany } from '../types/randomCompanies';

interface CompanyCardDetailsProps {
  company: RandomCompany;
  isNonOperating: boolean;
}

export const CompanyCardDetails: React.FC<CompanyCardDetailsProps> = ({
  company,
  isNonOperating
}) => {
  return (
    <>
      {/* Business Description */}
      {company.business_description && (
        <div className={`text-xs p-2 rounded ${
          isNonOperating 
            ? 'text-slate-600 bg-slate-800' 
            : 'text-slate-300 bg-slate-600'
        }`}>
          {company.business_description.length > 120 
            ? `${company.business_description.substring(0, 120)}...` 
            : company.business_description}
        </div>
      )}

      {/* Business Key Features */}
      {company.business_key_features && company.business_key_features.length > 0 && (
        <div className="space-y-1">
          {company.business_key_features.map((feature, index) => (
            <div key={index} className={`text-xs flex items-center gap-1 ${
              isNonOperating ? 'text-slate-600' : 'text-slate-400'
            }`}>
              <div className={`w-1 h-1 rounded-full ${
                isNonOperating ? 'bg-slate-600' : 'bg-slate-400'
              }`}></div>
              {feature}
            </div>
          ))}
        </div>
      )}

      {/* Category Tags */}
      {(company.logistics || company.packaging || company.d2c || company.b2b || company.b2c) && (
        <div className="flex flex-wrap gap-1">
          {[
            { key: 'logistics', label: 'Logistics', value: company.logistics },
            { key: 'packaging', label: 'Packaging', value: company.packaging },
            { key: 'd2c', label: 'D2C', value: company.d2c },
            { key: 'b2b', label: 'B2B', value: company.b2b },
            { key: 'b2c', label: 'B2C', value: company.b2c }
          ].filter(item => item.value).map(({ key, label }) => (
            <span 
              key={key} 
              className={`text-xs px-2 py-1 rounded ${
                isNonOperating 
                  ? 'bg-slate-800 text-slate-600' 
                  : 'bg-slate-600 text-slate-300'
              }`}
            >
              {label}
            </span>
          ))}
        </div>
      )}
    </>
  );
}; 